import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useRef, useState } from 'react';
import ReactResizeDetector from 'react-resize-detector/build/withPolyfill';
import { propArrayShape, propNumber, } from '../../../../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../../../../helpers/use/useHook';
import ArrowNextIcon from '../../../../../../Icon/Svg/ArrowNextIcon';
import ArrowPrevIcon from '../../../../../../Icon/Svg/ArrowPrevIcon';
import MultiFilesIcon from '../../../../../../Icon/Svg/MultiFilesIcon';
import Image from '../../../../../../Ui/Common/Image';
import Hover from '../../../../../../Ui/System/Hover';
const SlideView = (props) => {
    const { count, slides } = props;
    const ulRef = useRef();
    window.test = ulRef.current;
    const { boolState: isShowButton, changeFalse: hideButton, changeTrue: showButton, } = useBoolState(false);
    const [isShowOverview, changeIsShowOverview] = useState(false);
    const isShowOverviewRef = useRef(false);
    const onMouseEnter = useCallback(() => {
        const ul = ulRef.current;
        if (!ul) {
            return;
        }
        if (ul.scrollWidth > ul.clientWidth) {
            showButton();
        }
    }, [showButton]);
    /**
     * スライドのスクロールボタンをクリックした際のイベント
     * @type {(function(*): void)|*}
     */
    const onClickScroll = useCallback((e) => {
        const ul = ulRef.current;
        if (!ul) {
            return;
        }
        const width = 110;
        const { value } = e.currentTarget;
        const { scrollLeft } = ul;
        const index = scrollLeft / width;
        const rawUpdateIndex = index + (value === 'prev' ? -1 : 1);
        const mathUpdateIndex = value === 'prev'
            ? Math.ceil(rawUpdateIndex)
            : Math.floor(rawUpdateIndex);
        const updateIndex = Math.max(0, mathUpdateIndex);
        ul.scrollTo({ behavior: 'smooth', left: width * updateIndex });
    }, [ulRef]);
    /**
     * スクロールバーの表示有無を検知して、stateを更新するイベント
     * @type {(function(): void)|*}
     */
    const onResize = useCallback(() => {
        if (!ulRef.current) {
            return;
        }
        const { clientWidth, scrollWidth } = ulRef.current;
        const isOverflow = clientWidth < scrollWidth;
        if (isShowOverviewRef.current !== isOverflow) {
            isShowOverviewRef.current = isOverflow;
            changeIsShowOverview(isOverflow);
        }
    }, [ulRef, changeIsShowOverview, isShowOverviewRef]);
    if (slides.length === 0) {
        return (_jsx("div", Object.assign({ className: 'slide_card_view' }, { children: _jsx("div", Object.assign({ className: 'slide_card_empty' }, { children: "\u307E\u3060\u30B9\u30E9\u30A4\u30C9\u304C\u3042\u308A\u307E\u305B\u3093" })) })));
    }
    return (_jsx("div", Object.assign({ className: 'slide_card_view' }, { children: _jsx(Hover, Object.assign({ onMouseEnter: onMouseEnter, onMouseLeave: hideButton }, { children: _jsxs("div", Object.assign({ className: 'slide_card_list_box' }, { children: [isShowButton && (_jsx("button", Object.assign({ className: 'slide_view_scroll_btn prev', onClick: onClickScroll, type: 'button', value: 'prev' }, { children: _jsx(ArrowPrevIcon, {}) }))), _jsx(ReactResizeDetector, Object.assign({ onResize: onResize, targetRef: ulRef }, { children: _jsx("ul", Object.assign({ className: 'slide_card_list', ref: ulRef }, { children: slides.map((slide) => (_jsx("li", Object.assign({ className: 'slide_card_item' }, { children: _jsx(Image, { alt: '', className: 'slide_card_item_img', isObjectFit: true, src: slide.image, useImage: true }) }), slide.id))) })) })), isShowButton && (_jsx("button", Object.assign({ className: 'slide_view_scroll_btn next', onClick: onClickScroll, type: 'button', value: 'next' }, { children: _jsx(ArrowNextIcon, {}) }))), isShowOverview && (_jsxs("div", Object.assign({ className: 'slide_card_overview' }, { children: [_jsx("div", { className: 'slide_card_overview_bg' }), _jsxs("div", Object.assign({ className: 'slide_card_overview_content' }, { children: [_jsx("div", Object.assign({ className: 'slide_icon' }, { children: _jsx(MultiFilesIcon, {}) })), _jsx("div", Object.assign({ className: 'slide_number' }, { children: count })), _jsx("div", Object.assign({ className: 'slide_unit' }, { children: "Slides" }))] }))] })))] })) })) })));
};
SlideView.propTypes = {
    count: propNumber().isRequired,
    slides: propArrayShape().isRequired,
};
export default SlideView;
